import { render, staticRenderFns } from "./ModalFormularioConceptos.vue?vue&type=template&id=c071bf3c&scoped=true"
import script from "./ModalFormularioConceptos.vue?vue&type=script&lang=js"
export * from "./ModalFormularioConceptos.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioConceptos.vue?vue&type=style&index=0&id=c071bf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c071bf3c",
  null
  
)

export default component.exports